var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top"},[(_vm.config.mobile_logo)?_c('img',{staticClass:"logo",attrs:{"src":_vm.config.mobile_logo}}):_c('i',{staticClass:"logo"}),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.config.web_title))]),(_vm.config.web_slogan)?_c('p',{staticClass:"slogan"},[_vm._v(_vm._s(_vm.config.web_slogan))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }